import { FC, Key, useEffect, useState } from 'react';
import PageContainer from '../PageContainer';
import cs from 'classnames';
import styles from './index.module.less';
import { Button, Space, Tooltip } from 'antd';

interface Item {
  label?: string;
  value: any;
  disabled?: boolean;

}

interface LargeTagsProps {
  items?: Item[];
  title?: string;
  value?: Key[];
  onChange?: (key: Key[]) => void;
  tooltip?: string
}

const LargeTags: FC<LargeTagsProps> = ({ title, items = [], value, onChange, tooltip }) => {
  const [checkedKeys, setCheckedKeys] = useState<any[]>([]);

  const onChecked = (key) => {
    const newCheckKeys = [...checkedKeys];
    const index = newCheckKeys.indexOf(key);
    if (index === -1) {
      setCheckedKeys([...checkedKeys, key]);
      onChange?.([...checkedKeys, key]);
      return;
    }
    newCheckKeys.splice(index, 1);
    setCheckedKeys(newCheckKeys);
    onChange?.(newCheckKeys);
  };

  useEffect(() => {
    if (!value) {
      setCheckedKeys([]);
      return;
    }

    setCheckedKeys(value);
  }, [value]);

  const onClear = () => {
    setCheckedKeys([]);
    onChange?.([]);
  };

  return (
    <PageContainer
      title={ title && <Space>{title}<Button type='link' onClick={onClear}>清空</Button></Space>}
      nowrap={true}>
      {items.map(item => {
        const { label, value, disabled } = item;
        const checked = checkedKeys.includes(value);
        const wrapper = cs(styles['tag-content-wrapper'],
          [
            checked && styles['tag-content-checked-wrapper'],
            disabled && styles['tag-content-disabled-wrapper']
          ]);
        const content = cs(styles['tag-content'], [checked && styles['tag-content-checked']]);
        const onClick = () => {
          if (disabled) {
            return;
          }
          onChecked(value);
        };

        return (
          <div className={styles['tag-wrapper']} key={value} onClick={onClick}>
            {
              disabled ? (
                <Tooltip title={tooltip}>
                  <div className={wrapper}>
                    <div className={content}>
                      {label}
                    </div>
                  </div>
                </Tooltip>
              )
                : (
                  <div className={wrapper}>
                    <div className={content}>
                      {label}
                    </div>
                  </div>
                )
            }
          </div>
        );
      })}
    </PageContainer>
  );
};

export default LargeTags;

